// extracted by mini-css-extract-plugin
export default {"results":"EventzoneResults_results__iv4ks"};